/**
 * Feedback Form API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FeedbackTypeModel = 'COMMENTS_QUESTIONS' | 'BUG_REPORTS' | 'FEATURE_REQUEST';

export const FeedbackTypeModel = {
    CommentsQuestions: 'COMMENTS_QUESTIONS' as FeedbackTypeModel,
    BugReports: 'BUG_REPORTS' as FeedbackTypeModel,
    FeatureRequest: 'FEATURE_REQUEST' as FeedbackTypeModel
};

